import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Query } from '../../../App/global/functions/query';
import { TcsmStates } from '../../root/tcsm-model';
import { setSystemContext } from '../ducks/app-context';
import { getCurrentCycle } from '../ducks/mlps-api';
import { replaceAll } from '../helpers/string-helpers';
import { SystemContext } from '../models/app-context-model';

export const useSystemState = () => {
    const dispatch = useDispatch();
    const systemContextState = useSelector<TcsmStates, SystemContext>(state => state.appContext?.systemContext);

    useEffect(() => {
        if (!systemContextState) {
            // use parameter for sample date.
            const params = Query.getParams();
            const baseCycleParamToken = 'base_cycle_date';

            if (params && params[baseCycleParamToken]?.length === 1) {
                const baseCycle = params[baseCycleParamToken][0];
                const baseCycleDate = replaceAll(baseCycle, '-', '/');
                const testSystemContext: SystemContext = {
                    base_cycle_date: baseCycleDate,
                    current_statement_date: baseCycleDate,
                };

                dispatch(setSystemContext(testSystemContext));
            } else {
                dispatch(getCurrentCycle((data) => dispatch(setSystemContext(data)), () => dispatch(setSystemContext({
                    base_cycle_date: null,
                    current_statement_date: null,
                }))));
            }
        }
    }, [systemContextState]);

    return systemContextState;
};